module.exports = __webpack_public_path__ + "static/media/icon-en.936feee6.svg";